import { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  INDIA_MAP_VIEWBOX,
  INDIA_OUTLINE_PATH,
  UAE_OUTLINE_PATH,
  INDIA_MAP_CITIES,
  INTERNATIONAL_LOCATIONS,
} from "../../constant/IndiaMapData";

const IndiaDataCenterMap = () => {
  const navigate = useNavigate();
  const [activeCity, setActiveCity] = useState(null);

  return (
    <div className="relative mx-auto w-full">
      <svg
        viewBox={INDIA_MAP_VIEWBOX}
        className="h-auto w-full"
        role="img"
        aria-label="Map of India showing QuantaRock data center locations"
      >
        <path
          d={INDIA_OUTLINE_PATH}
          className="fill-[rgba(var(--website-secondary-rgb),0.06)] stroke-[rgba(var(--website-secondary-rgb),0.45)]"
          strokeWidth="0.75"
          strokeLinejoin="round"
        />
        <path
          d={UAE_OUTLINE_PATH}
          className="fill-[rgba(var(--website-secondary-rgb),0.06)] stroke-[rgba(var(--website-secondary-rgb),0.45)]"
          strokeWidth="0.75"
          strokeLinejoin="round"
        />

        {INDIA_MAP_CITIES.map((city) => {
          const isActive = activeCity === city.key;
          return (
            <g
              key={city.key}
              className="cursor-pointer"
              onMouseEnter={() => setActiveCity(city.key)}
              onMouseLeave={() => setActiveCity(null)}
              onClick={() => navigate(`/data-centers/${city.key}`)}
              tabIndex={0}
              role="link"
              aria-label={`View ${city.name} data center`}
              onFocus={() => setActiveCity(city.key)}
              onBlur={() => setActiveCity(null)}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(`/data-centers/${city.key}`);
              }}
            >
              {isActive && (
                <circle
                  cx={city.x}
                  cy={city.y}
                  r="4.5"
                  className="fill-[rgba(var(--website-secondary-rgb),0.25)]"
                >
                  <animate
                    attributeName="r"
                    values="3;6;3"
                    dur="1.4s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="opacity"
                    values="0.5;0;0.5"
                    dur="1.4s"
                    repeatCount="indefinite"
                  />
                </circle>
              )}
              <circle
                cx={city.x}
                cy={city.y}
                r={isActive ? "2.75" : "2"}
                strokeWidth="0.75"
                className={`transition-all duration-150 stroke-[var(--website-secondary-color)] ${
                  isActive
                    ? "fill-[var(--website-secondary-color)]"
                    : "fill-white"
                }`}
              />
              {isActive && (
                <g>
                  <rect
                    x={city.x - city.name.length * 1.7 - 4}
                    y={city.y - 13}
                    width={city.name.length * 3.4 + 8}
                    height="9"
                    rx="2"
                    className="fill-[var(--website-primary-dark)] stroke-[rgba(var(--website-secondary-rgb),0.4)]"
                    strokeWidth="0.5"
                  />
                  <text
                    x={city.x}
                    y={city.y - 6.5}
                    textAnchor="middle"
                    fontSize="5"
                    fontWeight="600"
                    className="fill-white"
                  >
                    {city.name}
                  </text>
                </g>
              )}
            </g>
          );
        })}

        {INTERNATIONAL_LOCATIONS.map((loc) => {
          const isActive = activeCity === loc.key;
          return (
            <g key={loc.key}>
              {loc.connectFrom && (
                <line
                  x1={loc.connectFrom.x}
                  y1={loc.connectFrom.y}
                  x2={loc.x}
                  y2={loc.y}
                  className="stroke-[rgba(var(--website-secondary-rgb),0.5)]"
                  strokeWidth="0.5"
                  strokeDasharray="1.5 2"
                />
              )}
              <g
                className="cursor-pointer"
                onMouseEnter={() => setActiveCity(loc.key)}
              onMouseLeave={() => setActiveCity(null)}
              onClick={() => navigate(`/data-centers/${loc.key}`)}
              tabIndex={0}
              role="link"
              aria-label={`View ${loc.name} data center`}
              onFocus={() => setActiveCity(loc.key)}
              onBlur={() => setActiveCity(null)}
              onKeyDown={(e) => {
                if (e.key === "Enter") navigate(`/data-centers/${loc.key}`);
              }}
            >
              {isActive && (
                <circle
                  cx={loc.x}
                  cy={loc.y}
                  r="4.5"
                  className="fill-[rgba(var(--website-secondary-rgb),0.25)]"
                >
                  <animate
                    attributeName="r"
                    values="3;6;3"
                    dur="1.4s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="opacity"
                    values="0.5;0;0.5"
                    dur="1.4s"
                    repeatCount="indefinite"
                  />
                </circle>
              )}
              <circle
                cx={loc.x}
                cy={loc.y}
                r={isActive ? "2.75" : "2"}
                strokeWidth="0.75"
                className={`transition-all duration-150 stroke-[var(--website-secondary-color)] ${
                  isActive
                    ? "fill-[var(--website-secondary-color)]"
                    : "fill-white"
                }`}
              />
              {isActive && (
                <g>
                  <rect
                    x={
                      loc.x -
                      Math.max(loc.name.length, loc.subLabel.length) * 1.5 -
                      4
                    }
                    y={loc.y - 20}
                    width={
                      Math.max(loc.name.length, loc.subLabel.length) * 3 + 8
                    }
                    height="15"
                    rx="2"
                    className="fill-[var(--website-primary-dark)] stroke-[rgba(var(--website-secondary-rgb),0.4)]"
                    strokeWidth="0.5"
                  />
                  <text
                    x={loc.x}
                    y={loc.y - 13.5}
                    textAnchor="middle"
                    fontSize="5"
                    fontWeight="600"
                    className="fill-white"
                  >
                    {loc.name}
                  </text>
                  <text
                    x={loc.x}
                    y={loc.y - 7.5}
                    textAnchor="middle"
                    fontSize="4"
                    className="fill-[var(--website-secondary-color)]"
                  >
                    {loc.subLabel}
                  </text>
                </g>
              )}
              </g>
            </g>
          );
        })}
      </svg>
    </div>
  );
};

export default IndiaDataCenterMap;
